export default "__VITE_ASSET__ML5Yj5Df__"